export const MOON_IMAGE_SPRING_CONFIGS_MAP = {
  1: {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  3: {
    from: { x: 100, y: 0, transform: 'scale(1)', opacity: 0 },
    to: { x: 0, y: 70, transform: 'scale(1.8)', opacity: 1 },
  },
};

export const SYMBOL_IMAGE_SPRING_CONFIGS_MAP = {
  1: {
    from: { x: -70, y: -150, transform: 'scale(1.683)' },
    to: { x: 0, y: 0, transform: 'scale(1)' },
  },
};

export const DESCRIPTION_SPRING_CONFIGS_MAP = {
  2: {
    from: { y: 0 },
    to: { y: -100 },
  },
  3: {
    from: { y: 0 },
    to: { y: 140 },
  },
};

export const SLIDES_COUNT = 3;
